import AirDatepicker from 'air-datepicker';
import select from '../../../form/select/select';

export default new class CartDeliveryData {
  constructor() {
    this.cartPreloader = 'cart__preloader';

    this.deliveryDataWrapperClass = 'cart-delivery-data__wrapper';

    this.calendarClass = 'js__calendar';
    this.dataActiveDays = 'data-active-days';
    this.dataMinDays = 'data-min-day';
    this.dataSelectDays = 'data-select-day';

    this.timeSelect = 'js-time__select';
    this.getSelectTimeDate = '_cart_delivery_time';

    this.extraHolidayClass = 'cart-delivery__extra-holidays';
    this.dataExtraHoliday = 'data-extra-holidays';

    this.isBasketPage = document.body.getAttribute('data-page-id') === 'basket';

    if (this.isBasketPage) {
      this.init();
    }
  }

  init() {
    this.updateDeliveryDataPartial();
  }

  updateDeliveryDataPartial() {
    $.request('onAjax', {
      update: {
        'product/cart/cart-delivery-data/cart-delivery-data': `.${this.deliveryDataWrapperClass}`,
      },
      loading: `.${this.cartPreloader}`,
      complete: () => {
        this.initCalendar();
        this.saveTime();
        select.checkSelect();
      },
    });
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  initCalendar() {
    const activeDays = [];
    let activeDate = false;
    let minDateDelivery = false;
    const extraHolidays = [];

    const calendarFields = document.querySelector(`.${this.calendarClass}`);

    if (!calendarFields) {
      return;
    }

    // Определяем минимальную дату доставки
    if (calendarFields.getAttribute(this.dataMinDays).length > 0) {
      const dateMin = calendarFields.getAttribute(this.dataMinDays);
      minDateDelivery = new Date(dateMin);
    }

    // Определяем активные для доставки дни недели
    if (calendarFields.getAttribute(this.dataActiveDays).length > 0) {
      calendarFields.getAttribute(this.dataActiveDays).split(',').forEach((_day) => {
        activeDays.push(parseFloat(_day));
      });
    }

    // Определяем дополнительные выходные дни
    const extraHolidayFields = document.querySelector(`.${this.extraHolidayClass}`);
    if (extraHolidayFields.getAttribute(this.dataExtraHoliday).length > 0) {
      extraHolidayFields.getAttribute(this.dataExtraHoliday).split('|').forEach((_date) => {
        const dateParts = _date.split('-');
        const extraHolidaysDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        extraHolidays.push(extraHolidaysDate[Symbol.toPrimitive]('number'));
      });
    }

    // Определяем последнюю активную дату доставки
    if (calendarFields.getAttribute(this.dataSelectDays).length > 0) {
      const dateParts = calendarFields.getAttribute(this.dataSelectDays).split('-');
      let activeParseDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      activeParseDate = activeParseDate[Symbol.toPrimitive]('number');

      if ((activeParseDate >= minDateDelivery[Symbol.toPrimitive]('number'))
        && !extraHolidays.includes(activeParseDate)) {
        activeDate = activeParseDate;
      } else {
        activeDate = minDateDelivery;
      }
    }

    // eslint-disable-next-line no-new
    new AirDatepicker(`.${this.calendarClass}`, {
      // visible: true,
      isMobile: true,
      multipleDates: false,
      showOtherMonths: false,
      autoClose: true,
      dateFormat: 'dd-MM-yyyy',
      selectedDates: activeDate,
      minDate: minDateDelivery,
      // eslint-disable-next-line consistent-return
      onRenderCell({ date, cellType }) {
        if (cellType === 'day') {
          const isDay = cellType === 'day';

          // Отсекаем все дни раньше минимальной даты доставки
          if (date[Symbol.toPrimitive]('number') < minDateDelivery[Symbol.toPrimitive]('number')) {
            return {
              disabled: true,
              // eslint-disable-next-line sonarjs/no-duplicate-string
              classes: 'disabled-class',
            };
          }

          // Отключаем дополнительные выходные дни
          const setExtraHoliday = isDay && extraHolidays.includes(date[Symbol.toPrimitive]('number'));
          if (setExtraHoliday) {
            return {
              disabled: true,
              classes: 'disabled-class',
            };
          }

          // Включаем доступный день для доставки
          // eslint-disable-next-line no-underscore-dangle
          const _date = date.getDay();
          const setActiveDay = isDay && activeDays.includes(_date);
          if (setActiveDay) {
            return {
              disabled: false,
            };
          }

          // Отсекаем все остальные дни для доставки
          return {
            disabled: true,
            classes: 'disabled-class',
          };
        }
      },
      onSelect: ({ formattedDate }) => {
        this.saveDate(formattedDate);
      },
    });
  }

  saveDate(selectDay) {
    $.request('DeliveryCalculation::onAjaxSetDate', {
      data: {
        selectDay,
      },
      type: 'POST',
      complete: () => {
        this.updateDeliveryDataPartial();
      },
    });
  }

  saveTime() {
    $(document).on('change', `.${this.timeSelect}`, (el) => {
      const { target } = el;

      const selectTime = target.value;

      $.request('DeliveryCalculation::onAjaxSetTime', {
        data: {
          selectTime,
        },
        type: 'POST',
      });
    });
  }
}();
